/*
Обязательные классы и атрибуты: i-cut, i-cut__inner, i-cut__action, i-cut__activator
Опционально можно указать дефолтный текст и текст подмены data-cut-text-default, data-cut-text-active

-----------------------------------------
Пример:
<div>
    Даже всемогущая пунктуация не имеет власти над рыбными текстами, ведущими безорфографичный образ жизни.
    Однажды одна маленькая строчка рыбного текста по имени Lorem ipsum решила выйти в большой мир
</div>
<div class="i-cut">
    <div class="i-cut__inner">
        Даже всемогущая пунктуация не имеет власти над рыбными текстами, ведущими безорфографичный образ жизни.
        Однажды одна маленькая строчка рыбного текста по имени Lorem ipsum решила выйти в большой мир
    </div>
    <div class="i-cut__action">
        <a href="#" class="i-cut__activator"
            data-cut-text-default="Развернуть описание"
            data-cut-text-active="Свернуть описание">
             Развернуть описание
        </a>
    </div>
</div>
*/

(function () {
    $(function () {
        const cutExpandedClassname = 'i-cut_state-expanded'
        const cutInitedClassname = 'i-cut_state-inited'
        
        $('.i-cut').each(function(){
            const $cut = $(this)
            let $inner // .i-cut__inner
            const $activator = $cut.find('.i-cut__activator')
            const textDefault = $activator.data('cut-text-default')
            const textActive = $activator.data('cut-text-active')
            let defaultHeight // дефолтная высота иннера

            $cut.on('init', event => {
                if (!$cut.hasClass(cutInitedClassname))
                    init()
            })
            
            if (!$cut.is('[data-no-init]')) {
                init()
            }
            
            // $cut.on('reinit', event => {
            //     if ($cut.hasClass(cutInitedClassname)) {
            //         const $inner = $cut.find('.i-cut__inner')
            //         $activator.off('click').show()
            //         toggleText ()
            //         $cut.removeClass(cutExpandedClassname + ' ' + cutInitedClassname)
            //         $inner.height($cut.attr('data-default-height'))
            //     }
            //     init()
            // })

            function init () {
                if ($cut.hasClass('i-cut_type-fixed')) {
                    $inner = $cut.find('.i-cut__inner')
                    defaultHeight = $inner.css('height') || 0
                    if (!$cut.is('[data-default-height]')) {
                        $cut.attr('data-default-height', $inner.css('height'))   
                    }
                    if ($inner.children().outerHeight() > parseInt(defaultHeight)) {
                        $activator
                            .on('click', function(event){
                                event.preventDefault()
                                event.preventDefault()
                                toggleState($inner)
                                toggleText()
                            })
                            .show()
                    } else {
                        $activator.hide()
                        $cut.addClass(cutExpandedClassname)
                    }
                } else {
                    $activator.on('click', function(e){
                        e.preventDefault()
                        $cut.toggleClass(cutExpandedClassname)
                        toggleText()
                    });
                }
                $cut.addClass(cutInitedClassname)
            }
            
            function toggleState ($inner) {
                if($cut.hasClass(cutExpandedClassname)) { // close
                    $inner.height($inner.get(0).scrollHeight).height(defaultHeight)
                    $cut.removeClass(cutExpandedClassname)
                } else { // open
                    $inner.height($inner.get(0).scrollHeight) // get height and open
                    $cut.addClass(cutExpandedClassname)
                }
            }
            
            function toggleText () {
                if (textDefault && textActive) {
                    $activator.text(($cut.hasClass(cutExpandedClassname)) ? textActive : textDefault)
                }
            }
        });
    })
}());
